import {type NestedTranslation, type TranslationObject} from './types.ts'

export function getNestedTranslation(primaryMessage: TranslationObject, nestedTranslations: NestedTranslation): TranslationObject {
    const nestedOptions = {}
    let doesNestedStringHaveInputVariables = false
    for(const key in nestedTranslations) {
        const nestedMessages = nestedTranslations[key]

        const nestedString = Array.isArray(nestedMessages) ? getNestedTranslationStrings(nestedMessages) : getNestedTranslationString(nestedMessages)

        nestedOptions[`${key}`] = nestedString

        if(doNestedMessageHaveInputVariables(nestedMessages)) doesNestedStringHaveInputVariables = true
    }

    const translationObject: TranslationObject = {
        key: primaryMessage.key,
        options: {
            ...primaryMessage.options,
            ...nestedOptions,
            interpolation: {
                escapeValue: !doesNestedStringHaveInputVariables,
            },
        },
    }

    return translationObject
}

function getNestedTranslationString(translationObject: TranslationObject): string {
    // eslint-disable-next-line
    return `$t(${translationObject.key}, ${JSON.stringify(translationObject.options)})`
}

function getNestedTranslationStrings(translationObjects: TranslationObject[]): string[] {
    const translationStrings: string[] = []
    for(const translationObject of translationObjects) {
        translationStrings.push(getNestedTranslationString(translationObject))
    }
    return translationStrings
}

function doNestedMessageHaveInputVariables(nestedMessages: TranslationObject | TranslationObject[]): boolean {
    const stringsToCheck: TranslationObject[] = Array.isArray(nestedMessages) ? nestedMessages : [nestedMessages]
    for(const stringToCheck of stringsToCheck) {
        if(stringToCheck.options != undefined) return true
    }
    return false
}
